import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApiService } from '../services/api.service';
import { ModalController} from '@ionic/angular';

import { Contact } from '../models/contact';

import { ContactsCreatePage } from '../contacts-create/contacts-create.page';

import { ContactSearchPipe } from '../pipes/contactSearchFilter.pipe';

@Component({
  selector: 'app-contacts-selector',
  templateUrl: './contacts-selector.component.html',
  styleUrls: ['./contacts-selector.component.scss'],
  providers: [ ContactSearchPipe ]
})
export class ContactsSelectorComponent implements OnInit {

  contactsData: Contact[];
  contactsDataGrouped: ContactGroup[] = [];
  filterTerm: string;

  constructor(
    public modalCtrl: ModalController, 
    public apiService: ApiService, 
    private contactSearchPipe: ContactSearchPipe) { }

  ngOnInit() {}

  ionViewWillEnter() {
    // Used ionViewWillEnter as ngOnInit is not 
    // called due to view persistence in Ionic
    this.getAllContacts();
  }

  getAllContacts() {
    // Get API list of contacts
    this.apiService.getContactList().subscribe(response => {

      // Filter out contacts that don't have a first name, last name, or business name
      this.contactsData = response.filter(contact => 
        (contact.first_name && contact.first_name.trim()) || 
        (contact.last_name && contact.last_name.trim()) || 
        (contact.business_name && contact.business_name.trim())
      );

      // Initial Sorting
      this.contactsData = this.contactsData.sort(
        (low, high) => (high.first_name || '').toLowerCase().trim() <  (low.first_name || '').trim().toLowerCase() ? 1 : -1
      );

      // Grouping is called by sorting algorithms
      this.groupByAlpha('first_name');

    })
  }

  handleSearch(event) {
    const query = event.target.value.toLowerCase();
    this.apiService.getContactListFiltered(query).subscribe(response => {
      
      // Filter out contacts that don't have a first name, last name, or business name
      this.contactsData = response.filter(contact => 
        (contact.first_name && contact.first_name.trim()) || 
        (contact.last_name && contact.last_name.trim()) || 
        (contact.business_name && contact.business_name.trim())
      );

      // Initial Sorting
      this.contactsData = this.contactsData.sort(
        (low, high) => (high.first_name || '').toLowerCase().trim() <  (low.first_name || '').trim().toLowerCase() ? 1 : -1
      );

      // Grouping is called by sorting algorithms
      this.groupByAlpha('first_name');
    })
  }

  groupByAlpha(param) {

    // Group our current contacts data
    const grouped = this.contactsData.reduce((groups, contact) => {
      const letter = contact[param].charAt(0).toUpperCase();

      groups[letter] = groups[letter] || [];
      groups[letter].push(contact);

      return groups;
    }, {});

    this.contactsDataGrouped = Object.keys(grouped).map(key => ({key, contacts: grouped[key]}));
  }

  dismiss() {  
    return this.modalCtrl.dismiss();
  }

  chooseContact(contact) {
    return this.modalCtrl.dismiss(contact, 'confirm');
  }

  async showNewContactModal() {  
    const modal = await this.modalCtrl.create({  
      component: ContactsCreatePage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const contact = data.data;

        if (contact != null){
          // TODO: Toast notification
          //this.presentToast('A new Contact was created.');

          // Refresh data
          this.getAllContacts();
        }
        else {
          // User has dismissed creating a new contact without saving
        }
    });

    await modal.present();
  }

}

interface ContactGroup {
  key: string;
  contacts: Contact[];
}